/**
 * High-frequency playhead for the viewer draw loop.
 * Zustand playhead is throttled during playback so React (timeline/panels) stay responsive.
 */
let livePlayhead = 0;
let lastStoreCommit = 0;

export function getLivePlayhead(): number {
  return livePlayhead;
}

export function syncLivePlayhead(t: number) {
  livePlayhead = Math.max(0, t);
}

/** Update live clock; optionally push to the editor store (throttled while playing). */
export function advanceLivePlayhead(
  t: number,
  commit: (next: number) => void,
  opts?: { force?: boolean; playing?: boolean; minMs?: number }
) {
  livePlayhead = Math.max(0, t);
  const minMs = opts?.minMs ?? (opts?.playing ? 66 : 0);
  const now = performance.now();
  if (opts?.force || now - lastStoreCommit >= minMs) {
    lastStoreCommit = now;
    commit(livePlayhead);
  }
}
